export const TravelsActionTypes = {
  API_RESPONSE_SUCCESS: '@@travels/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@travels/API_RESPONSE_ERROR',

  GET_TRAVEL: '@@travels/GET_TRAVEL',
  LIST_TRAVELS: '@@travels/LIST_TRAVELS',
  ADD_TRAVEL: '@@travels/ADD_TRAVEL',
  UPDATE_TRAVEL: '@@travels/UPDATE_TRAVEL',
  DELETE_TRAVEL: '@@travels/DELETE_TRAVEL',
  SET_FILTER: '@@travels/SET_FILTER',

  RESET: '@@travels/RESET'
}
